import { createClient } from '@supabase/supabase-js';
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabase = createClient(supabaseUrl, supabaseAnonKey);
export const submitFeedback = async (feedbackData) => {
  try {
    const { data, error } = await supabase.from('feedback').insert([feedbackData]);
    if (error) throw error;
    return { success: true, data };
  } catch (error) {
    return { success: false, error };
  }
};
